import { render } from "./InputPolicyNumber.vue?vue&type=template&id=22e81978&scoped=true"
import script from "./InputPolicyNumber.vue?vue&type=script&lang=js"
export * from "./InputPolicyNumber.vue?vue&type=script&lang=js"

import "./InputPolicyNumber.vue?vue&type=style&index=0&id=22e81978&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e81978"]])

export default __exports__